// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PRotateLeftOutlinedSvg from "@fishx/icons-svg/es/asn/PRotateLeftOutlined";
import FishxIcon from '../components/FishxIcon';

var PRotateLeftOutlined = function PRotateLeftOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PRotateLeftOutlinedSvg
  }));
};

PRotateLeftOutlined.displayName = 'PRotateLeftOutlined';
export default React.forwardRef(PRotateLeftOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PRotateLeftOutlined.js
// module id = 3603
// module chunks = 0